package co.diena.everything.app.worker

import co.diena.everything.api.EverythingApi
import io.ktor.client.HttpClient
import io.ktor.client.request.url
import io.ktor.http.HttpHeaders
import io.ktor.http.Url
import io.ktor.http.headers
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.onCompletion
import kotlinx.coroutines.flow.retryWhen
import kotlinx.coroutines.withTimeoutOrNull
import kotlinx.rpc.krpc.ktor.client.rpc
import kotlinx.rpc.krpc.ktor.client.rpcConfig
import kotlinx.rpc.krpc.serialization.json.json
import kotlinx.rpc.withService
import kotlin.time.Duration.Companion.seconds

sealed interface ClientState {
    data class Disconnected(val retryInSeconds: Int?) : ClientState
    data class Connected(val client: EverythingApi) : ClientState
}

fun makeClientStateFlow(
    rpcBackendUrl: Url,
    client: HttpClient,
): Flow<ClientState> {
    return flow<ClientState> {
        val rpcClient = client.rpc {
            url(rpcBackendUrl)

            rpcConfig {
                serialization {
                    json()
                }
            }
        }
        val service: EverythingApi = rpcClient.withService()
        service.hello()
        emit(ClientState.Connected(service))
        while (true) {
            delay(10.seconds)
            val result = withTimeoutOrNull(20.seconds) {
                service.hello()
            }
            if (result == null) {
                throw Throwable("Remote disconnected: timeout")
            }
        }
    }.onCompletion {
        throw Throwable("Remote disconnected: ${it?.message}")
    }.retryWhen { it, _ ->
        repeat(3) { i ->
            emit(ClientState.Disconnected(3 - i))
            delay(1.seconds)
        }
        true
    }
}